<mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
  <mat-tab label="{{ 'Details' | transloco }}">
    <tt-divider class="tt-guideline-sidebar_divider" />

    <div class="tt-guideline-flowchart-widget-sidebar_content">
      <h5 class="tt-guideline-flowchart-widget-sidebar_title">{{ 'GuidelineEditor.Sidebar.Flowchart.AddElement' | transloco }}</h5>
      <p class="tt-guideline-flowchart-widget-sidebar_description">
        {{ 'GuidelineEditor.Sidebar.Flowchart.DragElement' | transloco }}
      </p>

      <tt-flowchart-drag-palette class="tt-guideline-flowchart-widget-sidebar_drag-palette" />
    </div>
  </mat-tab>
</mat-tab-group>
